export enum SettingsPageKeys {
  settingsPage_settingsTitle = "settingsPage_settingsTitle",
  settingsPage_emailTemplatesString = "settingsPage_emailTemplatesString",
  settingsPage_manageTemplatesString = "settingsPage_manageTemplatesString",
  settingsPage_nameTableHeader = "settingsPage_nameTableHeader",
  settingsPage_templateTableHeader = "settingsPage_templateTableHeader",
  settingsPage_createdTableHeader = "settingsPage_createdTableHeader",
  settingsPage_actionTableHeader = "settingsPage_actionTableHeader",
}
